<modal-hl></modal-hl>
<toaster-by-subject></toaster-by-subject>
<div class="application">
    <div class="application__header" *ngIf="isAuthenticationPathResolved">
        <page-header></page-header>
    </div>
    <div class="application__content">
        <router-outlet></router-outlet>
    </div>
    <div class="application__footer">
        <page-footer></page-footer>
    </div>
    <genesys-constellation [participantData]="genesysParticipantData"></genesys-constellation>
</div>
